export function trackUpsellEvent(eventName, featureGateType) {
  mixpanel.track(eventName, {
    Tab: mp.report.globals.report_name,
    'Plan Type': (mp.report.globals.project_account_events_plan.name.match(/(Free|Startup|Business)/) || [])[0],
    'Feature Limit': {
      ab_testing: `A/B Testing`,
      bookmark: `Saved Reports`,
      cohorts: `Cohorts`,
      csv: `CSV Export`,
      custom_events: `Custom Events`,
      date_picker: `Data History`,
      data_management: `Data Management`,
      flows: `Flows`,
      formulas: `Formulas`,
      funnels: `Funnels`,
      platform: `Custom Apps`,
      predict: `Predict`,
      retention: `Retention`,
      revenue: `Revenue`,
      sampling: `Sampling`,
      security: `Two-Factor/SSO`,
      segmentation: `Segmentation`,
      signal: `Signal`,
      team: `Team Members`,
    }[featureGateType],
    'Limit Type': {
      ab_testing: `Feature Access`,
      bookmark: `Feature Limit`,
      cohorts: `Feature Access`,
      csv: `Feature Access`,
      custom_events: `Feature Limit`,
      date_picker: `Feature Limit`,
      data_management: `Feature Access`,
      flows: `Feature Access`,
      formulas: `Feature Access`,
      funnels: `Feature Limit`,
      platform: `Feature Access`,
      predict: `Feature Access`,
      retention: `Feature Limit`,
      revenue: `Feature Access`,
      sampling: `Feature Access`,
      security: `Feature Access`,
      segmentation: `Feature Limit`,
      signal: `Feature Access`,
      team: `Feature Limit`,
    }[featureGateType],
  });
}
